import { getRequest, postRequest } from "./config/request";

const SERVICE_URL = "/platform-billing";

export interface Invoice {
  id: string;
  amount: number;
  date: string;
  daysOverdue: number;
  status?: "Paid" | "Pending";
  dueDate?: string;
}

export interface BillingStatusResponse {
  isLocked: boolean;
  showWarning: boolean;
  daysRemaining: number;
  outstandingInvoice: Invoice | null;
}

export const getStatus = () => getRequest(`${SERVICE_URL}/status`);

export const getHistory = () => getRequest(`${SERVICE_URL}/history`);

export const payDues = (data: { invoiceId: string; reference: string }) =>
  postRequest(`${SERVICE_URL}/pay`, data);

export default {
  getStatus,
  getHistory,
  payDues,
};
